<template>
  <div class="app-header">
    <div class="header__right">
      <div class="header__time">
        <i class="el-icon-time"></i>
        <span>{{ currentTime }}</span>
      </div>
      <el-badge :value="notificationCount || null" :max="99">
        <button class="bell-btn" @click="handleNotification">
          <i class="el-icon-bell"></i>
        </button>
      </el-badge>
      <el-dropdown trigger="click" @command="handleCommand">
        <div class="user-info">
          <div class="user-avatar">
            <i class="el-icon-user-solid"></i>
          </div>
          <span class="user-name">{{ userName }}</span>
          <i class="el-icon-caret-bottom"></i>
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="logout" icon="el-icon-switch-button">退出登录</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'AppHeader',
  data() {
    return {
      currentTime: '',
      timer: null
    }
  },
  computed: {
    ...mapGetters(['userName', 'notificationCount'])
  },
  mounted() {
    this.updateTime()
    this.timer = setInterval(this.updateTime, 1000)
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
  methods: {
    updateTime() {
      const now = new Date()
      const pad = n => String(n).padStart(2, '0')
      this.currentTime = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())} ${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`
    },
    handleNotification() {
      this.$message({ message: '暂无新消息', type: 'info' })
    },
    handleCommand(command) {
      if (command === 'logout') {
        this.$confirm('确定要退出登录吗？', '退出确认', {
          confirmButtonText: '确定退出',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // 调用 Vuex action：接口退出 + 清 cookie + 清 store
          return this.$store.dispatch('logout')
        }).then(() => {
          this.$router.replace('/login')
        }).catch(() => {})
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.app-header {
  height: 56px;
  background: $white;
  border-bottom: 1px solid $border-color;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-shrink: 0;
  z-index: $z-header;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.06);
}

.header__right {
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 0 24px;
}

.header__time {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 13px;
  color: $text-muted;
  font-variant-numeric: tabular-nums;

  i { font-size: 14px; }
}

.bell-btn {
  width: 32px;
  height: 32px;
  border: none;
  background: transparent;
  cursor: pointer;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: $text-secondary;
  font-size: 17px;

  &:hover {
    background: $bg-gray;
    color: #1769E8;
  }
}

.user-info {
  display: flex;
  align-items: center;
  gap: 7px;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 6px;

  &:hover { background: $bg-gray; }
}

.user-avatar {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: #1769E8;
  display: flex;
  align-items: center;
  justify-content: center;
  color: $white;
  font-size: 14px;
  flex-shrink: 0;
}

.user-name {
  font-size: $font-sm;
  font-weight: $fw-medium;
  color: $text-primary;
}

.el-icon-caret-bottom {
  font-size: 12px;
  color: $text-muted;
}

::v-deep .el-dropdown-menu__item:hover {
  color: #1769E8;
  background: #eef4ff;
}
</style>
